/**
 * @typedef {'image' | 'pdf' | 'other'} FileCategory
 */

/**
 * Defines the possible file categories.
 * @enum {FileCategory}
 */
export const FileCategories = {
  IMAGE: 'image',
  PDF: 'pdf',
  OTHER: 'other',
};

/**
 * getFileType - Determine the MIME type and a broad category for a filename
 * @param {string} filename - The name or path of the file to check
 * @returns {{ mimeType: string, category: FileCategory }}
 */
export function getFileType(filename) {
  const lastDotIndex = filename.lastIndexOf('.');
  const ext =
    lastDotIndex === -1 || lastDotIndex === 0
      ? ''
      : filename.substring(lastDotIndex + 1).toLowerCase();

  const imageExtensions = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    svg: 'image/svg+xml',
    webp: 'image/webp',
    bmp: 'image/bmp',
    ico: 'image/vnd.microsoft.icon',
    tif: 'image/tiff',
    tiff: 'image/tiff',
  };

  if (ext in imageExtensions) {
    return { mimeType: imageExtensions[ext], category: FileCategories.IMAGE };
  }

  if (ext === 'pdf') {
    return { mimeType: 'application/pdf', category: FileCategories.PDF };
  }

  // Generic fallback
  const mimeType = 'application/octet-stream';
  return { mimeType, category: FileCategories.OTHER };
}
